var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsXRay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262 250",
    style: {
      enableBackground: "new 0 0 262 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B612C;}\r\n\t.st1{fill:#759C3E;}\r\n\t.st2{fill:#B7CA9D;}\r\n\t.st3{fill:#3C4929;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131,86.6 131,17 118.6,0 90.1,14.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131,17 131,5.2 118.6,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "131,86.6 100.1,32.1 69.1,24.2 98.5,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131,86.6 131,17 143.5,0 171.9,14.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131,17 131,5.2 143.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "131,86.6 161.9,32.1 192.9,24.2 163.5,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131,86.6 131,156.1 118.6,173.2 90.1,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131,156.1 131,167.9 118.6,173.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "131,86.6 100.1,141.1 69.1,149 98.5,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "69.1,24.2 54.3,32 76.1,86.6 54.3,141.2 69.1,149 98.5,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131,86.6 131,156.1 143.5,173.2 171.9,158.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131,156.1 131,167.9 143.5,173.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "131,86.6 161.9,141.1 192.9,149 163.5,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "207.7,32 192.9,24.2 163.5,86.6 192.9,149 207.7,141.2 186,86.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,226.6l-3.3,10.9H0l12.3-38.3h8.9l12.4,38.3h-7.5l-3.5-10.9H10.5z M21.5,221.3l-3-9.4c-0.7-2.3-1.4-4.9-1.9-7.2h-0.1 c-0.6,2.2-1.1,4.9-1.8,7.2l-3,9.4H21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,237.4l-9.4-38.3H40l3.6,17.4c1,4.7,1.9,9.5,2.5,13.4h0.1c0.6-4,1.7-8.6,2.8-13.4l4.1-17.3h7.3l3.8,17.6 c1,4.5,1.8,8.8,2.3,13h0.1c0.7-4.2,1.6-8.6,2.6-13.2l4-17.3h7.1l-10.3,38.3h-7.5l-4-18c-1-4.4-1.6-8-2.1-12.2h-0.1 c-0.7,4.1-1.4,7.8-2.6,12.2l-4.4,18H41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,229.8c2.3,1.3,5.7,2.4,9.3,2.4c4.5,0,7-2.1,7-5.2c0-2.9-1.9-4.6-6.8-6.4c-6.3-2.3-10.3-5.6-10.3-11.1 c0-6.2,5.2-11,13.5-11c4.1,0,7.2,0.9,9.2,1.9l-1.7,5.6c-1.4-0.7-4-1.8-7.6-1.8c-4.4,0-6.4,2.4-6.4,4.6c0,3,2.2,4.3,7.3,6.3 c6.6,2.5,9.9,5.9,9.9,11.4c0,6.1-4.7,11.5-14.5,11.5c-4,0-8.2-1.1-10.3-2.4L84.7,229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,237.4l-4.1-7.6c-1.6-3-2.7-5-3.8-7.2h-0.2c-0.9,2.2-1.9,4.3-3.5,7.2l-3.8,7.6h-8l11.4-19.4l-10.9-18.9h8l4.1,7.9 c1.3,2.4,2.2,4.3,3.2,6.4h0.1c1-2.4,1.8-4.1,3-6.4l4.1-7.9h8l-11.2,18.7l11.6,19.6H146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,219.9v4.8h-14.5v-4.8H171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,199.7c2.6-0.5,6.5-0.8,10.6-0.8c5.5,0,9.3,0.9,11.8,3.1c2.1,1.8,3.3,4.4,3.3,7.7c0,4.9-3.4,8.3-6.9,9.6v0.2 c2.7,1,4.4,3.7,5.3,7.4c1.2,4.8,2.2,9.2,3,10.7h-7.2c-0.6-1.1-1.5-4.3-2.6-9c-1.1-5-2.9-6.6-6.9-6.7h-3.5v15.7h-6.9V199.7z  M183.7,216.6h4.1c4.7,0,7.7-2.5,7.7-6.3c0-4.2-3-6.1-7.5-6.1c-2.2,0-3.6,0.2-4.3,0.3V216.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.9,237.4l-0.5-3.1h-0.2c-1.7,2.2-4.6,3.7-8.2,3.7c-5.6,0-8.7-4-8.7-8.2c0-7,6.2-10.5,16.4-10.4v-0.5 c0-1.8-0.7-4.8-5.6-4.8c-2.7,0-5.6,0.9-7.4,2l-1.4-4.5c2-1.2,5.6-2.4,10-2.4c8.9,0,11.4,5.6,11.4,11.6v10c0,2.5,0.1,4.9,0.4,6.6 H224.9z M224,223.9c-4.9-0.1-9.7,1-9.7,5.2c0,2.7,1.8,4,4,4c2.8,0,4.8-1.8,5.5-3.8c0.2-0.5,0.2-1.1,0.2-1.5V223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,209.8l5,14.8c0.6,1.7,1.1,3.8,1.5,5.4h0.2c0.5-1.6,1-3.6,1.5-5.5l4.3-14.8h7.5l-6.9,18.9c-3.8,10.3-6.4,14.9-9.7,17.8 c-2.7,2.4-5.6,3.4-7.3,3.6l-1.6-5.9c1.2-0.3,2.7-0.9,4.1-1.9c1.3-0.9,2.8-2.5,3.8-4.4c0.3-0.5,0.5-0.9,0.5-1.2 c0-0.3-0.1-0.7-0.4-1.4l-10.1-25.4H242z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsXRay);
export default __webpack_public_path__ + "static/media/aws-x-ray.0b81ed2a771c63b3a28808884c07eca9.svg";
export { ForwardRef as ReactComponent };